import TrackSearcher from './TrackSearcher';
import TrackStrip from './TrackStrip';
import TrackStripLabels from './TrackStripLabels';


export default {
  TrackSearcher,
  TrackStrip,
  TrackStripLabels
}



// WEBPACK FOOTER //
// ./src/locales/no/component/module/artist/misc/index.js